import React, { createContext, useContext } from "react";
import { node, shape, number, object } from "prop-types";
export var defaultValue = {
  parentRef: null,
  marginWidth: 0
};
export var MenuBarContext = /*#__PURE__*/createContext();
export var MenuBarProvider = function MenuBarProvider(_ref) {
  var children = _ref.children,
    initialValue = _ref.initialValue;
  return /*#__PURE__*/React.createElement(MenuBarContext.Provider, {
    value: initialValue
  }, children);
};
MenuBarProvider.propTypes = {
  children: node.isRequired,
  initialValue: shape({
    // eslint-disable-next-line react/forbid-prop-types
    parentRef: object,
    marginWidth: number
  })
};
MenuBarProvider.defaultProps = {
  initialValue: defaultValue
};
export var useMenuBar = function useMenuBar() {
  var _useContext = useContext(MenuBarContext),
    parentRef = _useContext.parentRef,
    marginWidth = _useContext.marginWidth;
  return {
    parentRef: parentRef,
    marginWidth: marginWidth
  };
};